export default __webpack_public_path__ + "static/media/SIW420G_K025_W00.ce691140.webp";